var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-checkbox",class:{
    'is-checked': _vm.isChecked,
    'is-top': _vm.isTop,
    'is-padding': _vm.setPadding
  },on:{"click":_vm.clicked}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }